// extracted by mini-css-extract-plugin
module.exports = {"main":"SaleActionBox_main__3BHU5","container":"SaleActionBox_container__3KNGR","notEnoughMana":"SaleActionBox_notEnoughMana__3iyLS"};